import React from "react";
import parse from "html-react-parser";
import type { IFaqComp } from "@src/types/AppTypes";

const FaqItem: React.FC<IFaqComp> = ({ faq, index, openIndex, setIndex }) => {
  return (
    <div className="relative bg-[#1D1159]">
      <button
        onClick={() => {
          if (openIndex === index) {
            setIndex(null);
          } else {
            setIndex(index);
          }
        }}
        className={`relative flex items-center justify-between w-full p-4 max-sm:p-3 font-semibold text-start ${
          faq.answer.replace(/<\/?[^>]+(>|$)/g, "").trim() !== ""
            ? "cursor-pointer"
            : ""
        }`}
        aria-label="Question"
        disabled={faq.answer.replace(/<\/?[^>]+(>|$)/g, "").trim() === ""}
      >
        <h2 className="text-primary-gradient text-2xl max-md:text-lg break-words max-w-[calc(100%-30px)]">
          {faq.question}
        </h2>
        {faq.answer.replace(/<\/?[^>]+(>|$)/g, "").trim() !== "" && (
          <i
            className={`ri-arrow-down-s-line text-primary bg-[#1b1359] rounded-full text-3xl accordion-icon ease-in duration-700 ${
              index === openIndex ? "open -rotate-[180deg]" : "closed"
            }`}
            onClick={() => {
              if (openIndex === index) {
                setIndex(null);
              } else {
                setIndex(index);
              }
            }}
          ></i>
        )}
      </button>
      {index === openIndex && (
        <div className="p-4 max-sm:p-3 text-2xl max-md:text-lg leading-normal text-white bg-secondary break-words">
          {parse(faq.answer)}
        </div>
      )}
    </div>
  );
};

export default React.memo(FaqItem);
